export const formatLocalDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const buildDateRange = (period, customDate) => {
  const baseDate = customDate ? new Date(customDate + 'T12:00:00') : new Date();
  const startDate = formatLocalDate(baseDate);
  const endDate = new Date(baseDate);

  if (period === 'day') {
    // single day — endDate stays same as startDate
  } else if (period === 'week') {
    endDate.setDate(endDate.getDate() + 6);
  } else if (period === 'quarter') {
    endDate.setMonth(endDate.getMonth() + 3);
    endDate.setDate(endDate.getDate() - 1);
  } else if (period === 'year') {
    endDate.setFullYear(endDate.getFullYear() + 1);
    endDate.setDate(endDate.getDate() - 1);
  } else {
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(endDate.getDate() - 1);
  }

  return { start_date: startDate, end_date: formatLocalDate(endDate) };
};

export const resetToCurrentPeriod = (period) => {
  const today = new Date();
  if (period === 'day') {
    return formatLocalDate(today);
  } else if (period === 'week') {
    const day = today.getDay();
    const diff = day === 0 ? 6 : day - 1;
    today.setDate(today.getDate() - diff);
    return formatLocalDate(today);
  } else if (period === 'month') {
    return formatLocalDate(new Date(today.getFullYear(), today.getMonth(), 1));
  } else if (period === 'quarter') {
    const qMonth = Math.floor(today.getMonth() / 3) * 3;
    return formatLocalDate(new Date(today.getFullYear(), qMonth, 1));
  } else if (period === 'year') {
    return formatLocalDate(new Date(today.getFullYear(), 0, 1));
  }
  return formatLocalDate(today);
};

export const shiftDate = (customDate, period, direction) => {
  const date = new Date(customDate + 'T12:00:00');
  const step = direction === 'next' ? 1 : -1;
  if (period === 'day') {
    date.setDate(date.getDate() + step);
  } else if (period === 'week') {
    date.setDate(date.getDate() + (step * 7));
  } else if (period === 'quarter') {
    date.setMonth(date.getMonth() + (step * 3));
  } else if (period === 'year') {
    date.setFullYear(date.getFullYear() + step);
  } else {
    date.setMonth(date.getMonth() + step);
  }
  return formatLocalDate(date);
};
